/**
 * V2 API 路徑不存在時重新整理一次：只用於「byod 已退版、仍開著新版頁面、後端已不認得 V2 路徑」的復原，
 * 重新整理後載入舊版 bundle、改打舊 API。
 *
 * 觸發條件依 API 而異，只認「後端沒有這條路徑」的訊號：
 * - 菜單（白名單路徑）：404，或 401 且錯誤碼屬 MISSING_ROUTE_401_CODES。白名單路徑仍會做 session 檢查，
 *   session 失效回的是 SESSION_INVALID / SESSION_EXPIRED / SESSION_KICK_OUT，照原流程重新登入；
 *   MISSING_ROUTE_401_CODES 只會在舊後端把不認得的路徑當成需登入路徑時出現：未帶 X-Auth-Token 的 POST
 *   先被 CSRF 檢查擋下（MISSING_/INVALID_CSRF_TOKEN_EXCEPTION），通過 CSRF 但未登入則是 UNAUTHORIZED。
 *   新後端的白名單路徑免 CSRF 也免登入，不會回這幾個碼。
 * - 購物車明細（需登入路徑）：只有 404；401 一律是 session 問題。
 */

const MISSING_ROUTE_401_CODES = [
	'UNAUTHORIZED',
	'MISSING_CSRF_TOKEN_EXCEPTION',
	'INVALID_CSRF_TOKEN_EXCEPTION',
]

export const MISSING_ROUTE_KIND = {
	MENU: 'menu',
	ITEM_DETAIL_LIST: 'itemDetailList',
}

export const RELOAD_GUARD_KEY = 'byod:missingRouteReloadAt'
export const RELOAD_GUARD_MS = 5 * 60 * 1000

export function isMissingRouteResponse(kind, status, errorCode) {
	if (status === 404) {
		return (
			kind === MISSING_ROUTE_KIND.MENU ||
			kind === MISSING_ROUTE_KIND.ITEM_DETAIL_LIST
		)
	}
	return (
		kind === MISSING_ROUTE_KIND.MENU &&
		status === 401 &&
		MISSING_ROUTE_401_CODES.includes(errorCode)
	)
}

/**
 * 是否可以重新整理，可以的話同時記下時間戳記（RELOAD_GUARD_MS 內只重新整理一次，防止迴圈）。
 * storage 無法存取或寫入未生效時回 false：寧可走原本的錯誤流程，也不冒無窮重新整理的風險。
 *
 * @param {Storage} storage 一般傳 sessionStorage
 * @param {number} now
 * @returns {boolean}
 */
export function claimMissingRouteReload(storage, now) {
	try {
		const last = Number(storage.getItem(RELOAD_GUARD_KEY))
		if (last && now >= last && now - last < RELOAD_GUARD_MS) {
			return false
		}
		storage.setItem(RELOAD_GUARD_KEY, String(now))
		return storage.getItem(RELOAD_GUARD_KEY) === String(now)
	} catch (e) {
		return false
	}
}
